import { mockData as documentAlertConfigData } from '@web/lib/demo/data/documentAlertConfig';
export var updateDocumentAlertConfig = function (input) {
    var documentAlertConfig = documentAlertConfigData.find(function (config) { return config.id === input.documentAlertConfigId; });
    if (!documentAlertConfig) {
        throw new Error('Document alert config not found');
    }
    return documentAlertConfig;
};
